<template>
  <div class="recipe-view">
    <recipe-categories :recipe="recipe" />
    <div class="content container">
      <div class="ingredients">
        <span>Ingredients</span>
        <div class="ingredients-content">
          <ingredients :ingredients="recipe.IngredientsList" />
        </div>
      </div>
      <div class="instructions">
        <span>Instructions</span>
        <div>
          <p v-for="instruction in instructionList" :key="instruction">
            {{instruction}}
          </p>
        </div>
        <div class="admin-buttons" v-if="$store.getters.hasPrivilege">
          <button
            class="lg-btn"
            @click="deleteFavorite"
            v-if="isFavorite || recipe.Favorite"
          >Remove from favorites</button>
          <button class="lg-btn" @click="setFavorite" v-else>Save as favorite</button>
        </div>
      </div>
      <similar-recipes />
    </div>
  </div>
</template>

<script>
import RecipeCategories from "@/components/pages/recipe/RecipeCategories";
import SimilarRecipes from "@/components/pages/recipe/SimilarRecipes";
import ingredients from "@/components/pages/recipe/Ingredients";
import { mapGetters } from "vuex";
import { db } from "@/firebase.js";
import recipeHelper from '@/helpers/recipeHelper'

export default {
  data() {
    return {
      recipe: {},
      initialIngredients: [],
      instructionList: []
    };
  },
  methods: {
    async setFavorite() {
      await db
        .collection("FavoriteRecipes")
        .doc(this.recipe.Id.toString())
        .set({});
      this.$store.dispatch("getFavorites");
    },
    async deleteFavorite() {
      await db
        .collection("FavoriteRecipes")
        .doc(this.recipe.Id.toString())
        .delete();
      this.$store.dispatch("getFavorites");
    }
  },
  created() {
    this.recipe = this.getRecipeById(this.$route.params.url);
    this.instructionList = recipeHelper.removeHtml(this.recipe.RecipeInstructions)
    this.$store.commit("setRecipeUrl", this.recipe.id);
    this.$store.commit("setTitle", this.recipe.Title);
    this.initialIngredients = this.recipe.IngredientsList;
  },
  computed: {
    ...mapGetters([
      "getRecipeById",
      "getRecipeDoneById",
      "getRecipeFavoriteById"
    ]),
    isDone() {
      return this.getRecipeDoneById(this.recipe.Id);
    },
    isFavorite() {
      return this.getRecipeFavoriteById(this.recipe.Id);
    }
  },
  components: {
    "recipe-categories": RecipeCategories,
    "similar-recipes": SimilarRecipes,
    ingredients
  }
};
</script>

<style lang="scss">
</style>